const DesktopIcon = ({ icon, label, onClick, active }) => {
    return (
        <button
            onClick={onClick}
            className={`flex cursor-pointer flex-col items-center rounded-lg p-2 transition ${active ? 'bg-[#0480B6]' : 'hover:bg-white/10'}`}
        >
            <img src={icon} alt={label} className="h-12 w-12" />
            <span className="mt-1 text-sm text-white">{label}</span>
        </button>
    );
};

export default DesktopIcon;
